export default __webpack_public_path__ + "static/media/check.5dcf9568.svg";